import { useTranslation } from "react-i18next";

import type { JackpotCampaign } from "@/campaigns/modules/jackpot/types";
import { Typography } from "@/components/ui/typography";

import { FinishedCampaignCard } from "./finished-campaign-card";

/**
 * Finished jackpot campaign in the results grid: the biggest payout it made, or the plain ended
 * word when it never paid out. Jackpot campaigns end by date, so the shared card's "Ended {{date}}"
 * is correct here — unlike a Sprint Mission that ran dry.
 */
export const FinishedJackpotCard = ({
  jackpotCampaign,
}: {
  jackpotCampaign: JackpotCampaign;
}) => {
  const { t } = useTranslation();
  let biggest: { value: number; display: string } | null = null;
  for (const view of jackpotCampaign.jackpots) {
    const last = view.events?.last;
    if (!last) continue;
    if (!biggest || last.payout_amount.value > biggest.value) {
      biggest = {
        value: last.payout_amount.value,
        display: last.payout_amount.display,
      };
    }
  }

  return (
    <FinishedCampaignCard campaign={jackpotCampaign.campaign}>
      <Typography tag="p">
        {biggest
          ? t("jackpot.biggestWin", "Biggest win {{amount}}", {
              amount: biggest.display,
            })
          : t("sprintMission.finishedShort", "Finished")}
      </Typography>
    </FinishedCampaignCard>
  );
};
